<section class="cds-card transactions-section">
  <header class="transactions-header">
    <h2 class="transactions-title">
      Lançamentos
    </h2>

    <!-- Download -->
    @if ((isDownloadEnabled$ | async) && canDownload()) {
      <bfm-download-button
        [contract]="downloadContract"
        [filters]="downloadFilters"
      />
    }
    <!-- ! Download -->
  </header>

  <caixa-webcomponent-data-table
    [data]="transactions()"
    [config]="tableConfig"
    [loading]="isLoading()"
    [shimmerRows]="pageSize()"
  />

  @if (!isLoading() && error()) {
    <p class="transactions-empty">
      Não foi possível carregar os lançamentos.
    </p>
  } @else if (totalItems() > 0) {
    <cds-pagination
      label="itens"
      [page]="page()"
      [totalPages]="totalPages()"
      [totalItems]="totalItems()"
      [offsetOptions]="pageSizeOptions"
      (currentPage)="onPageChange($event)"
      (offsetChange)="onOffsetChange($event)"
    />
  }
</section>
